import {
  IconCategoryCasing,
  IconCategoryCpuCooler,
  IconCategoryFan,
  IconCategoryGPU,
  IconCategoryHDD,
  IconCategoryMemory,
  IconCategoryMotherboard,
  IconCategoryProcessor,
  IconCategoryPSU,
  IconCategorySSD,
  IconCategoryAccessories,
  IconCategoryMonitor,
  IconCategoryKeyboardAndMouse,
  IconCategoryKeyboard,
  IconCategoryMouse,
} from "components";

import {
  PROCESSOR,
  MOTHERBOARD,
  MEMORY,
  GPU,
  SSD,
  HDD,
  PSU,
  CASING,
  CPU_COOLER,
  FAN,
  ACCESSORIES,
  MONITOR,
  KEYBOARD_MOUSE,
  KEYBOARD,
  MOUSE,
} from "modules/pcbuilder/constants";

import { ComponentName } from "modules/pcbuilder/types";

const mapCategoryIcon = (componentName: ComponentName) => {
  switch (componentName) {
    case PROCESSOR:
      return <IconCategoryProcessor sx={{ fontSize: 72 }} />;
    case MOTHERBOARD:
      return <IconCategoryMotherboard sx={{ fontSize: 72 }} />;
    case MEMORY:
      return <IconCategoryMemory sx={{ fontSize: 72 }} />;
    case GPU:
      return <IconCategoryGPU sx={{ fontSize: 72 }} />;
    case SSD:
      return <IconCategorySSD sx={{ fontSize: 72 }} />;
    case HDD:
      return <IconCategoryHDD sx={{ fontSize: 72 }} />;
    case PSU:
      return <IconCategoryPSU sx={{ fontSize: 72 }} />;
    case CASING:
      return <IconCategoryCasing sx={{ fontSize: 72 }} />;
    case CPU_COOLER:
      return <IconCategoryCpuCooler sx={{ fontSize: 72 }} />;
    case FAN:
      return <IconCategoryFan sx={{ fontSize: 72 }} />;
    case ACCESSORIES:
      return <IconCategoryAccessories sx={{ fontSize: 85 }} />;
    case MONITOR:
      return <IconCategoryMonitor sx={{ fontSize: 85 }} />;
    case KEYBOARD_MOUSE:
      return <IconCategoryKeyboardAndMouse sx={{ fontSize: 80 }} />;
    case KEYBOARD:
      return <IconCategoryKeyboard sx={{ fontSize: 80 }} />;
    case MOUSE:
      return <IconCategoryMouse sx={{ fontSize: 80 }} />;
    default:
      return null;
  }
};

export default mapCategoryIcon;
